import { render, staticRenderFns } from "./UnsyncedStatusIndicator.vue?vue&type=template&id=6977f3ab&"
import script from "./UnsyncedStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./UnsyncedStatusIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/web apps/HMS_Web_App_Vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
installComponents(component, {VAvatar,VChip})
